var map = {
	"./1/3.jpg": 1474,
	"./2/3.jpg": 3420,
	"./3/3.jpg": 3629,
	"./4/3.jpg": 9362,
	"./5/3.jpg": 5311,
	"./6/3.jpg": 3975,
	"./7/3.jpg": 1889,
	"./8/3.jpg": 4596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5088;